export function applyFiltersToData(data, filterModel = {}) {
  if (!filterModel || Object.keys(filterModel).length === 0) return data;

  return data.filter((item) => {
    return Object.entries(filterModel).every(([colId, filter]) => {
      const value = item[colId]?.toString()?.toLowerCase() ?? "";
      const filterVal = filter.filter.toString().toLowerCase();

      if (filter.filterType === "text") {
        if (filter.type === "contains") return value.includes(filterVal);
        if (filter.type === "equals") return value === filterVal;
        if (filter.type === "notEqual") return value !== filterVal;
        if (filter.type === "startsWith") return value.startsWith(filterVal);
        if (filter.type === "endsWith") return value.endsWith(filterVal);
        return true;
      }
      return true;
    });
  });
}

export function applySortToData(data, sortModel = []) {
  if (!sortModel || sortModel.length === 0) return data;

  const { colId, sort } = sortModel[0]; // Single column sort
  return [...data].sort((a, b) => {
    const aVal = (a[colId] || "").toString().toLowerCase();
    const bVal = (b[colId] || "").toString().toLowerCase();

    if (aVal < bVal) return sort === "asc" ? -1 : 1;
    if (aVal > bVal) return sort === "asc" ? 1 : -1;
    return 0;
  });
}
